import { useAgentContainer } from '@/context/agent-container.context';
import { useAgentPanel } from '@/context/agent-panel.context';
import { useAgentState } from '@/context/agent-state.context';

/**
 * Hands off to the Workbook's agent: opens the chat panel and sends `prompt`
 * with the page's module context plus `context`. Ready only while this
 * Workbook's editor has registered its agent module.
 */
export function useAskWorkbookAgent(workbookId: string) {
  const { moduleConfig } = useAgentContainer();
  const { open } = useAgentPanel();
  const { sendMessage, isLoading } = useAgentState();
  const ready =
    moduleConfig?.moduleKey === 'workbooks' &&
    moduleConfig.currentPage === `workbook:${workbookId}`;
  async function ask(prompt: string, context: Record<string, unknown> = {}) {
    if (!ready || isLoading) return;
    open();
    await sendMessage(
      prompt,
      'workbooks',
      moduleConfig.currentPage,
      { ...moduleConfig.getModuleContext?.(), ...context },
      moduleConfig.pageKey,
      moduleConfig.tools,
    );
  }
  return { ready, busy: isLoading, ask };
}
